import { z } from 'zod';

import { API_BASE_URL_DEFAULT } from '@/shared/config/api.constants';

const envSchema = z.object({
  MODE: z.enum(['development', 'production', 'test']),
  VITE_API_BASE_URL: z
    .string()
    .optional()
    .transform((v) => (v && v.length > 0 ? v : undefined)),
});

function parseEnv(): { mode: string; apiBaseUrl: string } {
  const raw = {
    MODE: import.meta.env.MODE,
    VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  };
  const result = envSchema.safeParse(raw);
  if (!result.success) {
    const msg = result.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`).join('; ');
    throw new Error(`Invalid environment: ${msg}`);
  }
  const apiBaseUrl = result.data.VITE_API_BASE_URL ?? API_BASE_URL_DEFAULT;
  return { mode: result.data.MODE, apiBaseUrl };
}

export const env = parseEnv();
